const roadmapPage = {
  toc: {
    today: "Staðan í dag",
    planned: "Áætlaðar útgáfur",
    influence: "Hafðu samband",
  },
  header: {
    epigraph: ["Vittu hvaðan þú komst", "og hvert þú ert að fara."],
    kicker: "Vegvísir",
    title: "Hvað er framundan",
  },
  sections: {
    today: {
      title: "Staðan í dag",
      body: "Kerfið gerir það sem því er ætlað: hægt er að hlaða upp gögnum, persónugreinanlegar upplýsingar eru fundnar og skipt út fyrir dulnefni, rannsakendur geta óskað eftir og fengið gögn, og hvert skref er skráð.",
      badge: "Tilbúið",
      intro: "Í stuttu máli, þetta virkar í dag:",
      items: {
        pseudonymization: {
          title: "Dulnefning",
          body: "hvert verkefni hefur sinn eigin lykil, svo dulnefni í einu verkefni er ekki hægt að para við annað. Upprunaleg gildi eru geymd dulkóðuð, svo heimiluð aflétting nafnleyndar er áfram möguleg og skráð.",
        },
        accounts: {
          title: "Notendaaðgangur og aðgangsstýring",
          body: "aðgangur eingöngu með boði, skyldubundin tveggja þátta innskráning, og hlutverk fyrir rannsakendur, verkefnisstjóra, deildarstjóra og gagnaveitendur.",
        },
        catalogue: {
          title: "Yfirlit gagnasafna",
          body: "lýsing á dálkum og samantektartölfræði, aðskilin stýring á því hver sér gagnasafn og hver má sækja það, og magnniðurhal með tilbúinni glósubók og R-skriftu.",
        },
        requests: {
          title: "Gagnabeiðnir",
          body: "rannsakendur velja dálkana sem þeir þurfa, verkefnisstjóri fer yfir beiðnina og hægt er að framsenda hana til utanaðkomandi gagnaveitenda.",
        },
        screening: {
          title: "Skimun við upphleðslu",
          body: "sjálfvirk skimun finnur líklegar persónuupplýsingar og forvelur þær, sá sem hleður upp getur merkt aðra dálka handvirkt, og manneskja staðfestir áður en nokkuð er vistað.",
        },
        expiry: {
          title: "Gildistími sem eyðir",
          body: "hægt er að setja gildistíma á gagnasafn við upphleðslu eða síðar. Þegar hann rennur út er gögnunum og lyklinum þeirra eytt og eyðingin skráð, svo kerfið stendur við varðveisluskilyrði siðanefndarleyfa.",
        },
        archiving: {
          title: "Verkefni í geymslu",
          body: "lokið verkefni má setja í geymslu, sem frystir það þar til það er endurvakið.",
        },
        notifications: {
          title: "Tilkynningar",
          body: "tilkynningar í kerfinu um beiðnir, upphleðslur og boð, auk tilkynninga frá verkefnisstjórum og deildarstjórum.",
        },
      },
    },
    planned: {
      title: "Áætlaðar útgáfur",
      intro: "Útgáfum er raðað í þeirri röð sem við ráðgerum að smíða þær. Dagsetningar eru áætlaðar og geta breyst.",
      partial: "að hluta tilbúið",
      releases: {
        v1_0: {
          badge: "Um 4. ársfj. 2026",
          title: "Útgáfa til framleiðslunotkunar",
          summary: "Það sem vantar upp á og öryggisúttektin.",
        },
        v1_1: {
          badge: "Um 1. ársfj. 2027",
          title: "Úttekt, aðgangur og tengingar",
          summary: "Yfirsýn yfir notkun, nákvæmari aðgangsstýring, formleg aflétting nafnleyndar og REDCap.",
        },
        v1_2: {
          badge: "Um 2. ársfj. 2027",
          title: "Útflutningur og þægindi",
          summary: "Fleiri leiðir til að sækja gögn og startpakkar.",
        },
        later: {
          badge: "Engin dagsetning enn",
          title: "Ekki tímasett",
          summary: "Stærri eiginleikar, eða þeir sem byggja á öðrum kerfum.",
        },
      },
      items: {
        sharingMode: {
          title: "Einn verkefnislykill eða lykill fyrir hvern rannsakanda",
          body: "í dag deila allir í verkefni einum lykli, svo sami einstaklingur hefur sama dulnefni hjá öllum og rannsakendur geta sameinað gögn hver annars. Með verkefnisstillingu fær hver rannsakandi í staðinn sinn eigin lykil og getur þá ekki tengt gögn sín við gögn annarra.",
        },
        directShare: {
          title: "Deila gögnum án beiðni",
          body: "verkefnisstjóri getur gefið öllum meðlimum eða völdum einstaklingum gögn beint. Í dag virkar þetta aðeins fyrir allt verkefnið, sem sjálfgefin stilling við upphleðslu.",
        },
        removeFiles: {
          title: "Fjarlægja skrár úr verkefni",
          body: "fjarlægja eina eða fleiri skrár úr verkefni.",
        },
        multiFileRequest: {
          title: "Óska eftir mörgum skrám í einu",
          body: "sækja um aðgang að fleiri en einni skrá í einni beiðni.",
        },
        excelDownload: {
          title: "Niðurhal á Excel sniði",
          body: "hlaða niður gögnum á Excel sniði.",
        },
        securityAudit: {
          title: "Öryggisúttekt",
          body: "óháð úttekt áður en kerfið er lýst tilbúið til framleiðslunotkunar.",
        },
        auditHistory: {
          title: "Notkunarsaga",
          body: "skoða eigin sögu, alla sögu verkefnis og, fyrir kerfisstjóra, sögu alls kerfisins. Gögnin eru þegar skráð.",
        },
        reidentification: {
          title: "Beiðnir um afléttingu nafnleyndar",
          body: "óska eftir og samþykkja afléttingu nafnleyndar fyrir lista af dulnefnum innan kerfisins, með öruggum hætti og samþykki fleiri en eins aðila. Útfærslan er ekki ákveðin enn. Þetta er hægt í dag með tölvupósti á help@irei.is, þar sem kerfisstjóri framkvæmir það og öll notkun er skráð.",
        },
        editAfterUpload: {
          title: "Breyta aðgangi eftir upphleðslu",
          body: "breyta því hver sér og hefur aðgang að gagnasafni eftir að því er hlaðið upp. Nú þegar er hægt að breyta gildistíma.",
        },
        promoteToPi: {
          title: "Hækka meðlim í verkefnisstjóra",
          body: "hækka núverandi meðlim úr meðlimalista verkefnisins. Hægt er að veita hlutverkið í dag þegar meðlimur er bætt við.",
        },
        shareEndDate: {
          title: "Lokadagsetning á deilingu",
          body: "aðgangur rennur út sjálfkrafa á völdum degi.",
        },
        redcap: {
          title: "REDCap-tenging",
          body: "sækja og dulnefna gögn úr REDCap-verkefni.",
        },
        redcapLinks: {
          title: "Tengd REDCap verkefni",
          body: "sjá hvaða REDCap verkefni eru tengd við verkefnið þitt.",
        },
        passThrough: {
          title: "Hlaða upp skrám án dulnefningar",
          body: "hlaða upp fylgiskrám sem þarf ekki að dulnefna.",
        },
        sasExport: {
          title: "SAS útflutningur",
          body: "hlaða niður gögnum á SAS sniði.",
        },
        batchUpload: {
          title: "Upphleðsla á mörgum skrám",
          body: "hlaða upp og dulnefna margar skrár í einu með sömu stillingum.",
        },
        starterPackage: {
          title: "Startpakki fyrir Python/R",
          body: "niðurhal inniheldur nú þegar glósubók og R-skriftu sem lesa gögnin inn. Næst: gagnaskýringaskrá og umhverfisskrár svo greining keyrir eins á hvaða tölvu sem er.",
        },
        nextcloud: {
          title: "Senda á Nextcloud",
          body: "senda gögn á þitt eigið Nextcloud gagnasvæði.",
        },
        crossProject: {
          title: "Samsvörun dulnefna milli verkefna",
          body: "gera kleift að para dulnefni milli tengdra verkefna. Flókið og þarf vandlegan undirbúning.",
        },
        lockProject: {
          title: "Læst verkefni",
          body: "læsa verkefni svo aðeins kerfisstjóri geti opnað það aftur.",
        },
        jupyterhub: {
          title: "Senda í JupyterHub",
          body: "senda gögn beint í öruggt JupyterHub vinnusvæði, svo þau þurfi aldrei að fara niður á einkatölvu. Í miklum forgangi, bíður þess að JupyterHub sé tilbúið til framleiðslunotkunar.",
        },
        remoteWorkspace: {
          title: "Öruggt fjarvinnuumhverfi",
          body: "ef glósubók dugar ekki, heilt skjáborð í vafra (til dæmis KASM Workspaces) fyrir verkfæri eins og RStudio, SAS eða Stata, án leiðar til að afrita gögn út. Aðeins ef verkefni þarf á því að halda.",
        },
      },
    },
    influence: {
      title: "Hafðu samband",
      intro: {
        before:
          "Áætlunin er sveigjanleg og áherslur koma frá fólkinu sem notar kerfið. Ef eitthvað vantar fyrir þína vinnu, láttu okkur vita. Hvorki eyðublað né tilkynningakerfi: einfaldur tölvupóstur til",
        after: "nær til fólksins sem byggir þetta.",
      },
      writeToUsBox: {
        kicker: "Hafðu samband á",
        welcomeIntro: "Allt eftirfarandi er velkomið:",
        items: {
          suggestions: {
            title: "Tillögur og óskir um nýjungar",
            body: "hvað myndi láta kerfið passa betur við hvernig hópurinn þinn vinnur í raun.",
          },
          bugReports: {
            title: "Villutilkynningar",
            body: "hvað þú gerðir, við hverju þú bjóst, og hvað gerðist í staðinn. Skjáskot og áætlaður tími hjálpa okkur að finna atvikið í annálunum.",
          },
          newDepartment: {
            title: "Óskir um nýja deild",
            body: "þetta er ætlað deildarstjóra deildar, stofnunar eða rannsóknareiningar sem vill fá sitt eigið afmarkaða svæði í kerfinu. Þið eruð líka velkomin að skrifa okkur til að bóka fund, kynningu og yfirferð yfir kerfið.",
          },
          questions: {
            title: "Spurningar áður en þú skuldbindur gögn",
            body: "um öryggislíkanið, hvað kerfið gerir ekki enn, eða hvað við gætum skuldbundið okkur til vegna siðanefndarumsóknar þinnar.",
          },
        },
      },
      contactNote:
        "Verkefnisstjórar og deildarstjórar geta einnig komið málum á framfæri við okkur, og þeir eru fyrstu tengiliðir þínir ef þig vantar aðstoð varðandi eigin aðgang eða reikning.",
      seeAlso: {
        before: "Um það hvernig kerfið virkar dags daglega, sjá",
        aboutLink: "Um kerfið",
        middle: "; um það hvernig þau eru varin, sjá",
        securityLink: "Öryggi",
      },
    },
  },
};

export default roadmapPage;
